import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { Box, Card, CardMedia, Typography } from "@mui/material";
import service from "services/constant";

const CustomeFilePreview = ({ files }) => {
  const getFileExtension = (path) => {
    return path?.split(".").pop().toLowerCase();
  };

  const fileArray = Array.isArray(files) ? files : files ? [files] : [];

  return (
    <Box display="flex" flexWrap="wrap" gap={2}>
      {fileArray?.length > 0 &&
        fileArray.map((file, index) => {
          const extension = getFileExtension(
            file?.imgPath || file?.name || file?.imagePath
          );

          if (file && !file?.imgPath && !file?.blobUrl) {
            if (file instanceof Blob || file instanceof File) {
              file.blobUrl = URL.createObjectURL(file);
            } else {
              console.error("Invalid file type for blob creation", file);
            }
          }

          const imageSource = file?.imgPath
            ? service?.IMG_URL + file?.imgPath
            : file?.imagePath
            ? service?.IMG_URL + file?.imagePath
            : file?.blobUrl;

          return (
            <a
              key={index}
              href={imageSource}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <Card
                sx={{
                  width: 200,
                  height: 100,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  p: 1,
                }}
              >
                {["jpeg", "jpg", "png", "gif", "webp", "svg"].includes(
                  extension
                ) ? (
                  <CardMedia
                    component="img"
                    image={imageSource}
                    alt={extension}
                    sx={{
                      width: "80%",
                      height: "auto",
                      objectFit: "contain",
                      maxHeight: "100%",
                    }}
                  />
                ) : extension === "pdf" ? (
                  <Box
                    position="relative"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    width="100%"
                    height="100%"
                  >
                    <PictureAsPdfIcon
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        fontSize: 20,
                        color: "red",
                      }}
                    />
                    <iframe
                      src={imageSource}
                      title="PDF Preview"
                      style={{ width: "100%", height: "100%", border: "none" }}
                    />
                  </Box>
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <InsertDriveFileIcon sx={{ fontSize: 50, color: "gray" }} />
                    <Typography
                      variant="caption"
                      sx={{ mt: 1, textAlign: "center" }}
                    >
                      File Preview Not Available
                    </Typography>
                  </Box>
                )}
              </Card>
            </a>
          );
        })}
    </Box>
  );
};

export default CustomeFilePreview;
